/* ── Overlay ──────────────────────────────────────────────── */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(4, 13, 24, 0.85);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 24px var(--sp-4) var(--sp-4);
  z-index: 200;
  overflow-y: auto;
}

.modal {
  width: 100%;
  max-width: 820px;
  background: var(--color-surface);
  border: 1px solid var(--color-border-med);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-strong);
  display: flex;
  flex-direction: column;
  height: calc(100vh - 48px);
  max-height: calc(100vh - 48px);
  overflow: hidden;
}

/* ── Header ──────────────────────────────────────────────── */
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: var(--sp-5) var(--sp-6);
  border-bottom: 1px solid var(--color-border);
  flex-shrink: 0;
}

.title {
  font-family: var(--font-mono);
  font-size: 16px;
  font-weight: 700;
  color: var(--color-text);
  letter-spacing: 0.5px;
}

.sub {
  font-size: 12px;
  color: var(--color-text-muted);
  margin-top: 3px;
}

.closeBtn {
  background: none;
  border: none;
  color: var(--color-text-muted);
  font-size: 18px;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: var(--radius-sm);
  line-height: 1;
  transition: color 0.15s, background 0.15s;
}

.closeBtn:hover { color: var(--color-text); background: rgba(255,255,255,0.05); }

/* ── Controls ────────────────────────────────────────────── */
.controls {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  padding: var(--sp-3) var(--sp-6);
  border-bottom: 1px solid var(--color-border);
  flex-shrink: 0;
}

.search {
  width: 100%;
  padding: var(--sp-2) var(--sp-4);
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  color: var(--color-text);
  font-family: var(--font-mono);
  font-size: 13px;
  outline: none;
  transition: border-color 0.15s;
}

.search::placeholder { color: var(--color-text-faint); }
.search:focus { border-color: var(--color-border-med); }

.pills {
  display: flex;
  gap: var(--sp-2);
  flex-wrap: wrap;
  padding-bottom: 2px;
}

.pill {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 500;
  padding: 3px 10px;
  border-radius: 20px;
  border: 1px solid var(--color-border);
  background: transparent;
  color: var(--color-text-muted);
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
}

.pill:hover {
  border-color: var(--color-border-med);
  color: var(--color-text);
}

.pillActive {
  background: rgba(56, 189, 248, 0.1);
  border-color: rgba(56, 189, 248, 0.35);
  color: var(--color-sky);
}

/* ── Body ────────────────────────────────────────────────── */
.body {
  flex: 1;
  overflow-y: auto;
  padding: var(--sp-4) var(--sp-6);
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
}

/* ── Section ─────────────────────────────────────────────── */
.section { display: flex; flex-direction: column; gap: var(--sp-4); }

.sectionLabel {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ── Grid ────────────────────────────────────────────────── */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: var(--sp-3);
}

/* ── Cards ───────────────────────────────────────────────── */
.card {
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--sp-4);
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  transition: border-color 0.2s;
}

.card:hover { border-color: var(--color-border-med); }

.cardDim { opacity: 0.6; }

.cardIcon {
  font-size: 20px;
  line-height: 1;
  color: var(--color-sky-dim);
}

.cardName {
  font-family: var(--font-mono);
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
}

.cardCat {
  font-size: 11px;
  color: var(--color-text-muted);
}

.cardDesc {
  font-size: 11px;
  color: var(--color-text-faint);
  line-height: 1.5;
}

.connectBtn {
  margin-top: auto;
  align-self: flex-start;
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: var(--radius-sm);
  background: rgba(56, 189, 248, 0.1);
  border: 1px solid rgba(56, 189, 248, 0.2);
  color: var(--color-sky);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.connectBtn:hover {
  background: rgba(56, 189, 248, 0.18);
  border-color: rgba(56, 189, 248, 0.4);
}

.notifyBtn {
  margin-top: auto;
  align-self: flex-start;
  font-family: var(--font-mono);
  font-size: 11px;
  padding: 4px 10px;
  border-radius: var(--radius-sm);
  background: transparent;
  border: 1px solid var(--color-border);
  color: var(--color-text-muted);
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
}

.notifyBtn:hover { border-color: var(--color-border-med); color: var(--color-text); }

.notifiedMsg {
  margin-top: auto;
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-success);
}

/* ── No results ──────────────────────────────────────────── */
.noResults {
  padding: var(--sp-8);
  text-align: center;
  font-size: 13px;
  color: var(--color-text-muted);
}

/* ── Request section ─────────────────────────────────────── */
.requestSection {
  border-top: 1px solid var(--color-border);
  padding-top: var(--sp-5);
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

.requestTitle {
  font-family: var(--font-mono);
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
}

.requestSub {
  font-size: 12px;
  color: var(--color-text-muted);
}

.requestForm {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

.requestInput,
.requestTextarea {
  width: 100%;
  padding: var(--sp-2) var(--sp-3);
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  color: var(--color-text);
  font-size: 13px;
  outline: none;
  resize: vertical;
  transition: border-color 0.15s;
}

.requestInput::placeholder,
.requestTextarea::placeholder { color: var(--color-text-faint); }

.requestInput:focus,
.requestTextarea:focus { border-color: var(--color-border-med); }

.requestSubmit {
  align-self: flex-start;
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 600;
  padding: var(--sp-2) var(--sp-4);
  border-radius: var(--radius-sm);
  background: rgba(56, 189, 248, 0.1);
  border: 1px solid rgba(56, 189, 248, 0.2);
  color: var(--color-sky);
  cursor: pointer;
  transition: background 0.15s;
}

.requestSubmit:hover:not(:disabled) { background: rgba(56, 189, 248, 0.18); }
.requestSubmit:disabled { opacity: 0.45; cursor: default; }

.requestSuccess {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--color-success);
  padding: var(--sp-2) var(--sp-3);
  background: rgba(34, 197, 94, 0.07);
  border: 1px solid rgba(34, 197, 94, 0.15);
  border-radius: var(--radius-sm);
}

/* ── Already-connected state ─────────────────────────────── */
.cardConnected {
  border-color: rgba(34, 197, 94, 0.2);
}

.instanceBadge {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-success);
  margin-bottom: 4px;
}

.addAnotherBtn {
  margin-top: auto;
  align-self: flex-start;
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: var(--radius-sm);
  background: rgba(34, 197, 94, 0.08);
  border: 1px solid rgba(34, 197, 94, 0.25);
  color: var(--color-success);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.addAnotherBtn:hover {
  background: rgba(34, 197, 94, 0.15);
  border-color: rgba(34, 197, 94, 0.4);
}
